import { normalizeBuddyVoiceId } from './buddyVoiceCatalog';

export const REACTION_KEYS = ['neutral', 'happy', 'excited', 'sad', 'caring', 'surprised', 'thinking'];

export const REACTION_PACKS = {
  leafy: { label: 'Leafy Classic', reactions: { neutral: '🌿', happy: '😊', excited: '✨', sad: '😢', caring: '💚', surprised: '😮', thinking: '🤔' } },
  simple: { label: 'Simple Faces', reactions: { neutral: '🙂', happy: '😄', excited: '🤩', sad: '😢', caring: '🥰', surprised: '😮', thinking: '🤔' } },
  animals: { label: 'Friendly Animals', reactions: { neutral: '🐻', happy: '🐶', excited: '🐵', sad: '🐰', caring: '🐼', surprised: '🦊', thinking: '🦉' } },
};

export const DEFAULT_BUDDY = {
  id: 'leafy', name: 'Leafy', image: '/leafy_icon.jpeg',
  reactionPackId: 'leafy', reactions: REACTION_PACKS.leafy.reactions,
  voice: 'ai_01', speed: 1,
  personality: 'Warm, patient, playful, and encouraging', presentation: 'static',
};

export const BUDDY_STORAGE_KEY = 'freeTalkBuddiesV1';

export const draftFromBuddy = (buddy) => ({
  name: buddy.name || '', personality: buddy.personality || '',
  reactionPackId: buddy.reactionPackId || 'custom',
  reactions: { ...REACTION_PACKS.simple.reactions, ...(buddy.reactions || {}) },
  voice: normalizeBuddyVoiceId(buddy.voice), speed: Number(buddy.speed) || 1,
  image: buddy.image || '', presentation: buddy.presentation || 'static',
});

export const newBuddyDraft = () => draftFromBuddy({
  name: '', personality: 'Friendly, patient, and playful',
  reactionPackId: 'simple', reactions: REACTION_PACKS.simple.reactions,
});

export const loadBuddies = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(BUDDY_STORAGE_KEY) || '[]');
    const normalized = saved.filter((buddy) => buddy?.id).map((buddy) => ({
      ...buddy,
      reactionPackId: buddy.reactionPackId || 'simple',
      reactions: buddy.reactions || {
        ...REACTION_PACKS.simple.reactions,
        neutral: buddy.emojis?.[0] || REACTION_PACKS.simple.reactions.neutral,
        happy: buddy.emojis?.[1] || REACTION_PACKS.simple.reactions.happy,
        excited: buddy.emojis?.[2] || REACTION_PACKS.simple.reactions.excited,
      },
    }));
    const savedLeafy = normalized.find((buddy) => buddy.id === 'leafy');
    return [{ ...DEFAULT_BUDDY, ...(savedLeafy || {}) }, ...normalized.filter((buddy) => buddy.id !== 'leafy')];
  } catch (_) {
    return [DEFAULT_BUDDY];
  }
};

export const apiBuddyToProfile = (buddy) => ({
  id: buddy.id,
  name: buddy.name,
  personality: buddy.persona_config?.personality || '',
  image: buddy.avatar_url || buddy.appearance_config?.fallbackAsset || '',
  reactions: { ...REACTION_PACKS.simple.reactions, ...(buddy.reaction_config?.reactions || {}) },
  reactionPackId: buddy.reaction_config?.packId || 'custom',
  voice: normalizeBuddyVoiceId(buddy.voice_config?.voice),
  speed: 1,
  presentation: buddy.appearance_config?.mode || 'static',
  capabilities: buddy.capabilities || {},
  isBuiltin: Boolean(buddy.is_builtin),
  isDefault: Boolean(buddy.is_default),
});
